import * as actionTypes from "../Action/Actiontypes";

const initialState = {
  loading: false,
  testimonials: [],
  total: 0,
  currentPage: 1,
  perPage: 10,
  lastPage: 1,
  error: null,
};

const ReviewReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_TESTIMONIALS_INIT:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actionTypes.FETCH_TESTIMONIALS_SUCCESS:
      return {
        ...state,
        loading: false,
        testimonials: action.payload.reviews,
        total: action.payload.total,
        currentPage: action.payload.current_page,
        perPage: action.payload.per_page,
        lastPage: action.payload.last_page,
        error: null,
      };

    case actionTypes.FETCH_TESTIMONIALS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case actionTypes.DELETE_TESTIMONIALS_SUCCESS:
      return {
        ...state,
        testimonials: state.testimonials.filter(
          (testimonial) => testimonial.id !== action.payload.id
        ),
        total: state.total - 1,
        error: null,
      };

    case actionTypes.DELETE_TESTIMONIALS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default ReviewReducer;
